<div #viewer class="view-container unselectable" [class.full-screen]="isFullScreen">
  <div class="view">
    <div class="image-container">
      @if (imgIndex >= imagesArray.length) {
      <div class="image-loading">
        <div class="spinner"></div>
        <p>{{ 'VIEWER.LOADING' | translate:{ page: currentPage } }}</p>
      </div>
      } @else {
      <img #image [hidden]="!this.imagesArray || !(this.imagesArray.length)" alt="document" [src]="imgShowing"
        [style.transform]="imgScale+imgTranslate+imgRotate">
      <canvas #canvas class="canvas-overlay" [style.transform]="imgScale+imgTranslate+imgRotate"></canvas>
      }
    </div>
    @if (currentImgLabel) {
    <div class="image-label">
      {{ currentImgLabel || "NAME_OF_CURENT_FILE_IMAGE.png" }}
    </div>
    }
  </div>

  <div class="btn-box">
    <button class="btn-v btn-dark btn-3" (click)="onRotate()">
      <fa-icon [icon]="icons.faUndo"></fa-icon>
    </button>

    <button class="btn-v btn-dark btn-2" (click)="onZoom('out')">
      <fa-icon aria-hidden="true" [icon]="icons.faSearchMinus"></fa-icon>
    </button>

    <div class="pagination">
      <fa-icon (click)="prevPage()" [icon]="icons.faArrowLeft" aria-hidden="true"></fa-icon>
      <span class="pages-label">
        {{ currentPage }}/{{ numOfPages || imagesArray.length || 0 }}
        @if (loading) {
        <span class="loading-indicator">...</span>
        }
      </span>
      <fa-icon (click)="nextPage()" [icon]="icons.faArrowRight" aria-hidden="true"></fa-icon>
    </div>

    <button class="btn-v btn-dark btn-2" (click)="onZoom('in')">
      <fa-icon aria-hidden="true" [icon]="icons.faSearchPlus"></fa-icon>
    </button>

    <button class="btn-v btn-dark btn-3" (click)="onReset()">
      <fa-icon [icon]="icons.faHistory" aria-hidden="true"></fa-icon>
    </button>
  </div>
</div>